module.exports = __webpack_public_path__ + "img/push-pin.057a333e.svg";